<template>
  <base-modal noCloseOnBackdrop noCloseOnScape hideClose :title="$t('filtersTitle')" v-model="localValue">
    <b-row class="appointments-filters">
        <b-col cols="12" md="6" offset-md="3"><base-input zeroMarginBottom v-model="filters.professionalName" :placeholder="$t('profName')"></base-input></b-col>
        <b-col cols="12" md="6" offset-md="3"><base-datepicker noMarginBottom :max="filters.toDate" resetButtton v-model="filters.fromDate" :placeholder="$t('from')"></base-datepicker></b-col>
        <b-col cols="12" md="6" offset-md="3"><base-datepicker noMarginBottom :min="filters.fromDate" resetButtton v-model="filters.toDate" :placeholder="$t('to')"></base-datepicker></b-col>
        <b-col cols="12" md="6" offset-md="3"><base-select clearable :options="appointmentsTypes" avoidDefaultSort valueProp="id" label="name" v-model="filters.appointmentType" :placeholder="$t('appointmentType')"></base-select></b-col>
    </b-row>
    <div class="search-btn mt-4">
        <base-button @click="filter">{{$t('search')}}</base-button>
        <base-button gray @click="resetFilters">{{$t('cancel')}}</base-button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import { getConsultationTitleById, INSURANCE } from '@/constants/consultationTypes'

export default {
    components: {
        BaseModal,
        BaseDatepicker
    },
    props: {
        value: Boolean
    },
    computed: {
        localValue: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            }
        }
    },
    created () {
        this.loadAppointmentsTypes()
    },
    data () {
        return {
            appointmentsTypes: [],
            filters: {
                fromDate: null,
                toDate: null,
                professionalName: null,
                appointmentType: null
            }
        }
    },
    methods: {
        filter () {
            this.$emit('filter', this.filters)
            this.localValue = false
        },
        loadAppointmentsTypes () {
            Object.keys(getConsultationTitleById()).filter(key => key !== INSURANCE.toString()).forEach(key => { this.appointmentsTypes.push({id: key, name: getConsultationTitleById(key)}) })
        },
        resetFilters () {
            let anyFilter = Object.keys(this.filters).some(key => { return this.filters[key] !== null })
            Object.keys(this.filters).forEach(key => { this.filters[key] = null })
            if (anyFilter) this.$emit('filter', {})
            this.localValue = false
        }
    }
}
</script>

<style lang="scss" scoped>
.search-btn{
    text-align: center;
}
.appointments-filters{
    gap: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/appointments/AppointmentsFilters.vue